import { FlexContainer } from '@/ui/styled-ui';
import { AppSwitch } from '@/ui/switch/AppSwitch';
import { InputSwitchChangeEvent } from 'primereact/inputswitch';
import React from 'react';
import styled from 'styled-components';

const StyledLabel = styled.label`
  font-size: var(--small-font-size);
  line-height: var(--small-line-height);
  font-weight: 500;
  margin-bottom: 0 !important;
  margin-left: var(--small-padding) !important;
`;

type CustomSwitchParams = {
  checked: boolean;
  onChange: (e: InputSwitchChangeEvent) => void;
  label: string;
  className?: string;
};

export const CustomSwitch: React.FC<CustomSwitchParams> = ({
  checked,
  onChange,
  label,
  className,
}) => {
  return (
    <FlexContainer className={className || 'mb-4'} justify="flex-start">
      <AppSwitch
        id="useCustom"
        name="useCustom"
        checked={checked}
        onChange={onChange}
        className="v2"
      />
      <StyledLabel htmlFor="useCustom">{label}</StyledLabel>
    </FlexContainer>
  );
};
